<template>
  <div class="footer">
    <div class="container_wrap">
      <div class="footer_cont clearfloat">
        <div class="footer_img">
          <div class="img_box">
            <img src="../assets/img/ewm.jpg" alt="" />
            <p>甘肃交通监理</p>
          </div>
          <!-- <div class="img_box">
            <img src="../assets/img/ewm1.jpg" alt="" />
            <p>甘肃华顺交通科技咨询公司</p>
          </div> -->
          <div class="img_box">
            <img src="../assets/img/ewm2.jpg" alt="" />
            <p>甘肃华强试验检测公司</p>
          </div>
        </div>
        <p>
          <span>公司电话：0931-8615070</span>
          <span>邮箱：gsjtjl@163.com</span>
          <span>地址：兰州市城关区和平新村127号元富大厦7-8F</span>
        </p>
      </div>
      <div class="footer_bottom">
        Copyright 2009 甘肃省交通工程建设监理有限公司 All Reserved
        <a
          href="https://beian.miit.gov.cn/"
          target="_blank"
          style="cursor: pointer"
          >备案许可证号：陇ICP备13000406号</a
        >
        <br />
        <img src="../assets/img/ggwab.png" alt="" />
        <a
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=62010202001059"
          target="_blank"
          style="cursor: pointer"
          >甘公网安备 62010202001059号</a
        >
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  components: {},
  data() {
    return {};
  },
};
</script>

<style scoped>
.footer {
  background: #fafafa;
  margin-top: 60px;
  border-top: 10px solid #1970b9;
  padding-top: 20px;
  padding-bottom: 10px;
  line-height: 34px;
}
.footer_cont {
  text-align: center;
}
.footer_cont span {
  margin: 0 10px;
}
.footer_bottom {
  text-align: center;
  line-height: 34px;
}
.footer_bottom img {
  vertical-align: middle;
}
.footer_img {
  text-align: center;
  margin: 18px auto 10px;
  font-size: 14px;
}
.footer_img .img_box {
  display: inline-block;
  margin-left: 15px;
}
.footer_img img {
  width: 140px;
}
.footer_cont .fl {
  width: 33%;
}
.footer_link a {
  margin: 0 10px;
}
.footer_link a:hover {
  color: #1970b9;
}
</style>